export enum OEvents {
  CHATBOT_RESIZE = "chatbot_resize",
  CHATBOT_OPEN = "chatbot_open",
  CHATBOT_HOST_URL_REDIRECT = "chatbot_host_url_redirect",
  CHATBOT_SESSION_CHANGE = "chatbot_session_change",
  CHATBOT_CONFIGURATION = "chatbot_configuration",
  TRACKING_EVENTS = "tracking_events",
  LIVECHAT_SESSION_CHANGE = "livechat_session_change",
  CHATBOT_SESSION_ID = "chatbot_session_id",
  CHATBOT_SHOW_NOTIFICATION = "chatbot_show_notification",
  CHATBOT_OPEN_PIP = "chatbot_open_pip",
  CHATBOT_CLOSE_PIP = "chatbot_close_pip",
  CHATBOT_PIP_CONFIRMED = "chatbot_pip_confirmed",
  CHATBOT_MESSAGES_SYNC = "chatbot_messages_sync",
  CHATBOT_REQUEST_MESSAGES_SYNC = "chatbot_request_messages_sync",
  CHATBOT_FORWARD_SMARTAI_QUERY = "chatbot_forward_smartai_query",
  CHATBOT_REQUEST_NOTIFICATION_PERMISSION = "chatbot_request_notification_permission",
}

export enum IEvents {
  CHATBOT_START = "chatbot_start",
  CHATBOT_SAVE_VISITOR_ID = "chatbot_save_visitor_id",
  PARENT_WINDOW_RESIZE = "parent_window_resize",
  LOCATION = "location",
  CHATBOT_MESSAGES_SYNC = "chatbot_messages_sync",
  CHATBOT_REQUEST_MESSAGES_SYNC = "chatbot_request_messages_sync",
  CHATBOT_FORWARD_SMARTAI_QUERY = "chatbot_forward_smartai_query",
  CHATBOT_PIP_OPENED = "chatbot_pip_opened",
  CHATBOT_PIP_CLOSED = "chatbot_pip_closed",
}

export const INCOMING_EVENTS = new Set([
  IEvents.CHATBOT_START,
  IEvents.CHATBOT_SAVE_VISITOR_ID,
  IEvents.PARENT_WINDOW_RESIZE,
  IEvents.LOCATION,
  IEvents.CHATBOT_MESSAGES_SYNC,
  IEvents.CHATBOT_REQUEST_MESSAGES_SYNC,
  IEvents.CHATBOT_FORWARD_SMARTAI_QUERY,
  IEvents.CHATBOT_PIP_OPENED,
  IEvents.CHATBOT_PIP_CLOSED,
]);
export const OUTGOING_EVENTS = new Set([
  OEvents.CHATBOT_RESIZE,
  OEvents.CHATBOT_OPEN,
  OEvents.CHATBOT_HOST_URL_REDIRECT,
  OEvents.CHATBOT_SESSION_CHANGE,
  OEvents.CHATBOT_CONFIGURATION,
  OEvents.TRACKING_EVENTS,
  OEvents.LIVECHAT_SESSION_CHANGE,
  OEvents.CHATBOT_SESSION_ID,
  OEvents.CHATBOT_SHOW_NOTIFICATION,
  OEvents.CHATBOT_OPEN_PIP,
  OEvents.CHATBOT_CLOSE_PIP,
  OEvents.CHATBOT_PIP_CONFIRMED,
  OEvents.CHATBOT_MESSAGES_SYNC,
  OEvents.CHATBOT_REQUEST_MESSAGES_SYNC,
  OEvents.CHATBOT_FORWARD_SMARTAI_QUERY,
  OEvents.CHATBOT_REQUEST_NOTIFICATION_PERMISSION,
]);

export class CommMessage {
  event_type: IEvents | OEvents;
  data: any;

  constructor(event_type: IEvents | OEvents, data: any) {
    this.event_type = event_type;
    this.data = data;
  }
}

export enum TrackingEventTypes {
  GTM_CONVERSION = "gtm_conversion",
  MATOMO_CONVERSION = "matomo_conversion",
  MATOMO_SET_USER_ID = "matomo_set_user_id",
}

export enum MatomoEvent {
  CATEGORY = "chatbot",
  CHAT_OPEN_ACTION = "chat_open",
  CHAT_OPEN_NAME = "user_chat_open",

  CHAT_CONVERSION_ACTION = "chat_conversion",
  CHAT_CONVERSION_NAME = "user_chat_conversion",
}
